import { ref } from 'vue'
interface RestaurantItem {
  value: string
  title: string
}
const createFilter = (queryString: string) => {
  return (restaurant: RestaurantItem) => {
    return (
      restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
    )
  }
}

const restaurants = ref<RestaurantItem[]>([
  { title: 'PY-666', value: 'PY-666' },
  { title: 'PY-518', value: 'PY-518' },
  { title: 'YX-666', value: 'YX-666' },
  { title: 'YX-518', value: 'YX-518' },
  { title: '热点先锋', value: '热点先锋' },
  { title: '赢家有道', value: '赢家有道' },
  { title: '财经早参', value: '财经早参' },
  { title: '午市狙击', value: '午市狙击' },
  { title: '滚雪球', value: '滚雪球' },
  { title: '老程开小灶', value: '老程开小灶' },
  { title: '培你论市', value: '培你论市' }
])

export function useSearchVideoTitle() {
  const fetchSuggestions = (queryString: string, cb: any) => {
    const results = queryString
      ? restaurants.value.filter(createFilter(queryString))
      : restaurants.value
    // call callback function to return suggestions
    cb(results)
  }
  return [fetchSuggestions]
}

export function useSearchDuration() {
  return [
    { title: '≥ 1分钟', value: '60' },
    { title: '≥ 5分钟', value: '300' },
    { title: '≥ 10分钟', value: '600' },
    { title: '≥ 20分钟', value: '1200' },
    { title: '≥ 25分钟', value: '1500' },
    { title: '≥ 30分钟', value: '1800' },
    { title: '≥ 40分钟', value: '2400' },
    { title: '≥ 50分钟', value: '3000' },
    { title: '≥ 60分钟', value: '3600' }
  ]
}

export function useSearchDays() {
  return [
    { title: '≥ 3天', value: '3' },
    { title: '≥ 4天', value: '4' },
    { title: '≥ 5天', value: '5' },
    { title: '≥ 6天', value: '6' },
    { title: '≥ 7天', value: '7' },
    { title: '≥ 8天', value: '8' },
    { title: '≥ 9天', value: '9' },
    { title: '≥ 10天', value: '10' }
  ]
}

export function useSearchDateShortcut() {
  const startOfDay = (date: Date) => {
    date.setHours(0, 0, 0, 0)
    return date
  }
  const endOfDay = (date: Date) => {
    date.setHours(23, 59, 59, 0)
    return date
  }

  return [
    {
      text: '今天',
      value: () => {
        const end = endOfDay(new Date())
        const start = startOfDay(new Date())
        return [start, end]
      }
    },
    {
      text: '昨天',
      value: () => {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1)
        end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
        return [startOfDay(start), endOfDay(end)]
      }
    },
    {
      text: '近7天',
      value: () => {
        const end = endOfDay(new Date())
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
        return [startOfDay(start), end]
      }
    },
    {
      text: '近30天',
      value: () => {
        const end = endOfDay(new Date())
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
        return [startOfDay(start), end]
      }
    }
  ]
}
